module.exports = __webpack_public_path__ + "img/h3.d632baa1.png";